import { Document, Packer, Paragraph, TextRun, PageBreak, Header, Footer, AlignmentType } from 'docx';
import { saveAs } from 'file-saver';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

export async function downloadSetlistDocx(setlist, songs) {
  const getSongById = (songId) => songs.find(s => s.id === songId);

  const headerText = `${setlist.name} — ${formatDate(setlist.date)}`;

  const sections = (setlist.sets || []).map((set, setIndex) => {
    const children = [];

    // Set heading
    children.push(
      new Paragraph({
        spacing: { after: 300 },
        children: [
          new TextRun({
            text: set.name.toUpperCase(),
            bold: true,
            underline: {},
            size: 72, // 36pt (half-points)
          }),
        ],
      })
    );

    let songNumber = 1;
    (set.items || []).forEach((item) => {
      if (item.type === 'song' && item.song_id) {
        const song = getSongById(item.song_id);
        const title = song?.title || 'Unknown Song';
        const artist = song?.artist || 'Unknown Artist';

        // Song title line: numbered
        children.push(
          new Paragraph({
            spacing: { after: 40 },
            children: [
              new TextRun({
                text: `${songNumber}. ${title}`,
                bold: true,
                size: 56, // 28pt
              }),
            ],
          })
        );

        // Artist line
        children.push(
          new Paragraph({
            spacing: { after: 200 },
            children: [
              new TextRun({
                text: `    ${artist}`,
                italics: true,
                size: 40, // 20pt
                color: '888888',
              }),
            ],
          })
        );

        songNumber++;
      } else if (item.type === 'banter') {
        const name = item.banter?.name || 'Banter';
        children.push(
          new Paragraph({
            spacing: { after: 200 },
            alignment: AlignmentType.LEFT,
            children: [
              new TextRun({
                text: `-- ${name} --`,
                italics: true,
                size: 36, // 18pt
                color: '888888',
              }),
            ],
          })
        );
      }
    });

    return {
      properties: {
        page: {
          margin: { top: 1440, bottom: 1440, left: 1440, right: 1440 },
        },
      },
      headers: {
        default: new Header({
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: headerText,
                  size: 18, // 9pt
                  color: '999999',
                }),
              ],
            }),
          ],
        }),
      },
      footers: {
        default: new Footer({
          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new TextRun({
                  text: `Page ${setIndex + 1} of ${setlist.sets.length}`,
                  size: 16, // 8pt
                  color: '999999',
                }),
              ],
            }),
          ],
        }),
      },
      children,
    };
  });

  const doc = new Document({ sections });

  const blob = await Packer.toBlob(doc);
  const filename = `${slugify(setlist.name)}-setlist.docx`;
  saveAs(blob, filename);
}
